import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import GiftsListView from "./gifts-list.html";
import GiftsEditView from "./gifts-edit.html";


angular.module("gifts", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('gifts', {
                url: "/gifts",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('gifts.list', {
                url: "/list",
                controller: "GiftsListCtrl", 
                template: GiftsListView,
                data: { pageTitle: 'Almacén de regalos' },
                requiredPermission: ["GIFTS_READ"]
            })            
            .state('gifts.edit', {
                url: "/edit/:id",
                controller: "GiftsEditCtrl",
                template: GiftsEditView,
                data: { pageTitle: 'Almacén de regalos' },
                requiredPermission: ["GIFTS_READ"]
            })
    }])
;